import { isRouteErrorResponse, useRouteError } from 'react-router';

// A page that failed to load or render, shown in place of the page with the navigation kept.
// The usual cause straight after a release is a page chunk the browser no longer finds: a
// reload fetches the new version. The current portal had no error element, so React Router's
// default "Unexpected Application Error" replaced the whole portal.
export function RouteError() {
  const error = useRouteError();
  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : String(error);
  const staleChunk = /dynamically imported module|Importing a module script failed|error loading dynamically/i.test(message);
  console.error('page failed', error);

  return (
    <div role="alert" style={{ padding: '2rem 0' }}>
      <h1 style={{ marginBottom: '0.75rem' }}>
        {staleChunk ? 'A newer version of the portal is available' : 'Something went wrong on this page'}
      </h1>
      {!staleChunk && <p style={{ color: 'var(--color-danger)' }}>{message}</p>}
      <p style={{ color: 'var(--color-text-muted)' }}>
        Reloading the page usually clears this. If it keeps happening, quote the message above to the helpdesk.
      </p>
      <button type="button" onClick={() => window.location.reload()}>Reload the page</button>
    </div>
  );
}
